import React, { useState } from 'react';
import './Testimonials.css';

const testimonials = [
  {
    text: "Embrace Beauty changed my life! My hair is fuller and healthier than ever. The team made me feel comfortable throughout the process.",
    name: "Sarah T.",
  },
  {
    text: "The PRP skin rejuvenation treatment was incredible. My skin looks years younger and the staff was absolutely professional and caring.",
    name: "Emily R.",
  },
  {
    text: "I had Botox injections and the results were amazing. Very natural looking. I highly recommend Embrace Beauty Aesthetics to everyone!",
    name: "Jennifer M.",
  },
  {
    text: "After my hair transplant, the post-treatment PRP sessions at Embrace Beauty made a huge difference. The team is knowledgeable and kind.",
    name: "David K.",
  },
  {
    text: "Tessy and her team are simply the best. My skin texture has improved so much after the micro-needling sessions. Truly life-changing.",
    name: "Amanda L.",
  },
];

const Testimonials = () => {
  const [active, setActive] = useState(0);

  const prev = () => setActive((active - 1 + testimonials.length) % testimonials.length);
  const next = () => setActive((active + 1) % testimonials.length);

  return (
    <section className="testimonials-section">
      <div className="container testimonials-inner">
        <div className="testimonials-carousel">
          <div className="quote-icon">❝</div>
          <p className="testimonial-text">{testimonials[active].text}</p>
          <p className="testimonial-author"><strong>{testimonials[active].name}</strong></p>

          <div className="carousel-controls">
            <button className="carousel-btn" onClick={prev}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M15 18l-6-6 6-6"/></svg>
            </button>
            <div className="carousel-dots">
              {testimonials.map((_, i) => (
                <button
                  key={i}
                  className={`dot ${i === active ? 'active' : ''}`}
                  onClick={() => setActive(i)}
                />
              ))}
            </div>
            <button className="carousel-btn" onClick={next}>
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M9 18l6-6-6-6"/></svg>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
